export const GET_FINANCIAL_INSTITUTION_DISCLAIMERS_AND_FINE_PRINT_SUCCESS = 'GET_FINANCIAL_INSTITUTION_DISCLAIMERS_AND_FINE_PRINT_SUCCESS';
export const GET_FINANCIAL_INSTITUTION_DISCLAIMERS_AND_FINE_PRINT_FAIL = 'GET_FINANCIAL_INSTITUTION_DISCLAIMERS_AND_FINE_PRINT_FAIL';

export const GET_BROWSER_TAB_TITLE_SUCCESS = 'GET_BROWSER_TAB_TITLE_SUCCESS';
export const GET_BROWSER_TAB_TITLE_FAIL = 'GET_BROWSER_TAB_TITLE_FAIL';

export const GET_DESIGN_TEMPLATE_SETTINGS_SUCCESS = 'GET_DESIGN_TEMPLATE_SETTINGS_SUCCESS';
export const GET_DESIGN_TEMPLATE_SETTINGS_FAIL = 'GET_DESIGN_TEMPLATE_SETTINGS_FAIL';
